import $ from 'jquery'

$(document).ready(function($) {
	if (!$('body').hasClass('home')) return

	$('.banner .slides').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		autoplay: true
	})
})
